const PATCH_NOTES = [
  {
    title: `Version ${process.env.VUE_APP_VERSION}`,
    date: '2025-05-09', // '09 de Mayo de 2025',
    changes: [
      {
        title: 'New multi-language functionality',
        description: [
          'English\', \'French\', \'German\', \'Catalan\', \'Galician\' and \'Basque\' languages are added.',
        ]
      },
      {
        title: 'Change in Agenda',
        description: [
          'Agenda changes its name to \'Societies\'.',
          'The sections \'Related Companies\' and \'History\' are added to Societies.',
          'Added \'Contact e-mail\' and \'Bank accounts\' sections to Locations.',
        ]
      },
      {
        title: 'New Invoice Issuing Interface module.',
        description: [
          'It is necessary to have the \'Invoice Issuing\' module activated for correct operation.',
          'New functionality added to issue invoices by steps.',
          'Invoice issuing steps \'Participants\', \'Detail\', \'Lines\', \'Payment\' and \'Attachments\' have been added.',
          'Invoice summary is added.',
        ]
      },
      {
        title: 'New Veri*Factu module.',
        description: [
          'Veri*Factu records added.',
          'Added \'Correct\', \'Accepted with errors\', \'Incorrect\' and \'To be reported\' statuses.',
          'Record detail is added.',
        ]
      },
      {
        title: 'Bug fixes',
        description: [
          'Minor bug fixes.'
        ]
      },
    ]
  },
  {
    title: 'Version 6.1.0',
    date: '2024-09-09', // '09 de Septiembre de 2024',
    changes: [
      {
        title: 'AAD/SAML2 Authentication Configuration',
        description: [
          'Authentication module with integration through Azure Active Directory',
          'Authentication module with integration through the SAML2 standard',
          'Dynamic login based on user authentication type'
        ]
      },
      {
        title: 'New Webhooks modules',
        description: [
          'Two new modules are added for the events of Invoices Issued and Received',
          'A new Webhook configuration view is added. Integration with Microsoft Teams or Custom Integration (Zerocoma)'
        ]
      },
      {
        title: 'New TicketBAI-Batuz module',
        description: [
          'A configuration section is added for integration with TicketBAI-Batuz.'
        ]
      },
      {
        title: 'Change in the \'External Shipping\' flow',
        description: [
          'The \'External Shipping\' status is removed.',
          'Invoices that are in this status will go to the \'Sent\' status.',
          'Invoices with pge \'External Shipping\' now go through the normal invoice flow.'
        ]
      },
      {
        title: 'Elimination of actions on issued invoices',
        description: [
          'All \'Go to\' actions are removed from invoices in \'Unsent\' status.'
        ]
      },
      {
        title: 'Bug fixes',
        description: [
          'Minor bug fixes.'
        ]
      },
    ]
  },
  {
    title: 'Version 6.0.0',
    date: '2024-09-09', // '09 de Septiembre de 2024',
    changes: [
      {
        title: 'New Agenda functionality',
        description: [
          'A section is added where you can add different types of contacts.'
        ]
      },
      {
        title: 'New Validation functionality',
        description: [
          'The invoice files are compared with their schemas and the attachments are checked prior to uploading the invoice.'
        ]
      },
      {
        title: 'New Templates functionality',
        description: [
          'A new configuration is added with default values ​​for the creation of new companies and new groups.'
        ]
      },
      {
        title: 'New Self-Invoicing module',
        description: [
          'The option to upload and issue self-invoices from the platform is added.'
        ]
      },
      {
        title: 'New Groupings module',
        description: [
          'A section is added to create sets of entities (Companies, Suppliers or Customers) and use them later in filters and other parts of the application.'
        ]
      },
      {
        title: 'New Personalization module',
        description: [
          'Different customization options are added such as: Logos, colors, SMTP account and personalized emails.'
        ]
      },
      {
        title: 'New PDF Template module',
        description: [
          'The option to generate a pdf invoice from the invoice is added based on an established template and configuration.'
        ]
      },
      {
        title: 'New product from EdasInvoiZEFiles',
        description: [
          'The option to upload invoices with their attachments from the EdasInvoiZEFiles service is added.'
        ]
      },
      {
        title: 'Possibility of uploading received invoices',
        description: [
          'The option to upload invoices received manually is added from the "Upload invoices" menu.'
        ]
      },
      {
        title: 'Filter Reorganization',
        description: [
          'The filters of the sections related to invoices are reorganized.'
        ]
      },
      {
        title: 'Bug fixes',
        description: [
          'Minor bug fixes.'
        ]
      },
    ]
  },
  {
    title: 'Version 5.2.2',
    date: '2024-03-20', // '20 de Marzo de 2024',
    changes: [
      {
        title: 'Text correction',
        description: [
          'Some texts are corrected in the licensing validation.'
        ]
      },
      {
        title: 'Bug fixes',
        description: [
          'The disappearance of the "Detail" column from the tables related to invoices is corrected.'
        ]
      },
    ]
  },
  {
    title: 'Version 5.2.1',
    date: '2024-03-18', // '18 de Marzo de 2024',
    changes: [
      {
        title: 'Text update',
        description: [
          'Some texts within the application are updated for greater descriptiveness.'
        ]
      },
      {
        title: 'Efficiency improvements',
        description: [
          'Improvements are made to the efficiency of selectors within the application.'
        ]
      },
      {
        title: 'Bug fixes',
        description: [
          'Minor bug fixes.'
        ]
      },
    ]
  },
  {
    title: 'Version 5.2.0',
    date: '2024-02-27', // '27 de Febrero de 2024',
    changes: [
      {
        title: 'Expanded schemes supported for issuance',
        description: [
          'Compatibility and validation of other schemes apart from Facturae is added.'
        ]
      },
      {
        title: 'Signing and recovery of invoices for external shipping',
        description: [
          'The General Delivery Point External Shipping is added, useful for only signing invoices to be sent externally.'
        ]
      },
      {
        title: 'New General Delivery Point Catalonia (e-Fact)',
        description: [
          'The e-Fact General Delivery Point is added for sending invoices to the administrations of Catalonia that are not members of FACe.',
          'Consult the participating administrations in #link:eFact#.'
        ],
        links: [
          {
            tag: 'eFact',
            linkName: 'e-Fact',
            url: 'https://efact.aoc.cat/bustia/receiver/list.htm'
          }
        ]
      },
      {
        title: 'Recovery of sent files',
        description: [
          'If the invoice to be sent has undergone any alteration for shipment to the General Delivery Point, it will be stored as a document related to the invoice.'
        ]
      },
      {
        title: 'Third party signature',
        description: [
          'All those Invoices that are signed through the Social Collaborator certificate will have our data included as third parties in the ThirdParty node of the Facturae.'
        ]
      },
      {
        title: 'Bug fixes',
        description: [
          'Errors related to existing transformers.',
          'Minor bug fixes.'
        ]
      },
    ]
  },
  {
    title: 'Version 5.1.0',
    date: '2024-02-06', // '06 de Febrero de 2024',
    changes: [
      {
        title: 'New features',
        description: [
          'New Dashboard functionality: New view with useful information about invoices and licensing.'
        ]
      },
      {
        title: 'Other changes',
        description: [
          'Minor fixes.',
        ]
      },
    ]
  },
  {
    title: 'Version 5.0.0',
    date: '2024-02-06', // '06 de Febrero de 2024',
    changes: [
      {
        title: 'New features',
        description: [
          'New Distributor functionality: Manage multiple clients as a distributor with licensing exchange or free-form provisioning.',
        ]
      },
    ]
  }, 
  {
    title: 'Version 4.2.0',
    date: '2023-10-30', // '30 de Octubre de 2023',
    changes: [
      {
        title: 'New features',
        description: [
          'New Groups functionality. Tags are now groups, groups maintain the tag functionality and add: user management, expanded invoice management.',
          'Updating the user profile with information about the groups to which they belong.',
        ]
      },
    ]
  }, 
  {
    title: 'Version 4.1.0',
    date: '2023-08-11', // '11 de Agosto de 2023',
    changes: [
      {
        title: 'New features',
        description: [
          'Incorporation of receipt of invoices in the PGE FACe and FACeB2B.',
          'New modules available to hire. You can check them in the general settings section.'
        ]
      },
    ]
  }, 
  {
    title: 'Version 4.0.0',
    date: '2023-05-24', // '24 de Mayo de 2023',
    changes: [
      {
        title: 'Launch',
        description: [
          // 'Management and administration of...',
        ]
      },
    ]
  }, 
  // {
  //   title: 'Version 2.11.0',
  //   date: '2022-12-13', // '13 de Diciembre de 2022',
  //   changes: [
  //     {
  //       title: 'New features',
  //       description: [
  //         'New user type: Query User. User for data consultation and review, similar to the "User" role with restrictions when performing actions on invoices, you can only view them and download their content.',
  //         'New functionality for editing and deleting Additional Metadata from an invoice, accessible in the invoice details.',
  //         'The option to export an Excel file of detected errors has been added from the Dashboard error details dialog box.',
  //         'A new option has been added to export an Excel file of the complete history of detected errors, for a specific company and headquarters, from the error details dialog box of the Dashboard.',
  //         'When selecting the "Exclude associated organization" action from the invoice view, the option to exclude said organization from all the client\'s companies has been added, in addition to maintaining the default option of only excluding the organization from the company associated with that invoice. .',
  //       ]
  //     },
  //     {
  //       title: 'Fixed bugs',
  //       description: [
  //         'Corrected error in uploading invoices manually.',
  //         'Corrections in texts and descriptions.',
  //         'Other minor fixes',
  //       ]
  //     },
  //   ]
  // }, 
]

export {
  PATCH_NOTES
}

